import React, { useEffect, useState } from "react";
import { Loader, Select } from "@mantine/core";
import useTagsListApiService from "../services/api/TagsListApiService";
import { HttpClientError } from "../../../providers/HttpClient";

type TagCategorySelectProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any;
};

const TagCategorySelect: React.FC<TagCategorySelectProps> = ({ form }) => {
  const {
    isLoading: isTagLoading,
    isSuccess,
    isError,
    error,
    data: tagData,
  } = useTagsListApiService({});

  const [categories, setCategories] = useState<string[]>([]);
  const id = "category";
  const title = "Category";
  const placeholder = "Select category";
  const description = "Select an existing category or create a new one";

  useEffect(() => {
    if (isSuccess && tagData) {
      const tempData: string[] = [];
      tagData.forEach((it) => {
        if (!tempData.find((search) => Object.is(search, it.category))) {
          tempData.push(it.category);
        }
      });

      setCategories(tempData);
    }
  }, [isSuccess]);

  if (isError) {
    return (
      <Select
        id={id}
        label={title}
        description={description}
        placeholder={placeholder}
        name={id}
        data={[]}
        disabled
        error={HttpClientError(error)}
      />
    );
  }

  if (!tagData) {
    return (
      <Select
        id={id}
        name={id}
        data={[]}
        label={title}
        description={description}
        placeholder="No tags available"
        disabled
      />
    );
  }

  return (
    <Select
      {...form.getInputProps(id, { type: "select" })}
      data={categories}
      label={title}
      description={description}
      placeholder={placeholder}
      rightSection={isTagLoading ? <Loader size={16} /> : null}
      nothingFound="No options"
      getCreateLabel={(query) => `+ Create ${query}`}
      onCreate={(query) => setCategories((current) => [...current, query])}
      searchable
      creatable
      clearable
      required

    />
  );
};

export default TagCategorySelect;
